import React, {Component} from 'react';
import {render} from 'react-dom';

import { userService } from '../_services';

export default class AccountDropdown extends React.Component {
    constructor(props) {
        super(props);
        
        var state = {
            accounts: ""
        };

        if (props.authenticatedUser) {
            Object.assign(state, {
                accounts: props.authenticatedUser.accounts
                    .map(account => <option key={account.value} value={account.value}>{account.label}</option>)
            });
        }

        this.state = state;
    }

    render() {
        return (
            <select
                className={this.props.className}
                name={this.props.name}
                value={this.props.value}
                onChange={this.props.onChange}>
                {this.state.accounts}
            </select>
        )
    }
}